export enum SalesCallActionKeys {
  ADD_SALESCALL = 'ADD_SALESCALL',
  ADD_INFO_SALESCALL = 'ADD_INFO_SALESCALL',
  ADD_SALESCALL_REJECTED = 'ADD_SALESCALL_REJECTED',
  DELETE_SALESCALL = 'DELETE_SALESCALL',
  DELETE_SALESCALL_FULFILLED = 'DELETE_SALESCALL_FULFILLED',
  DELETE_SALESCALL_REJECTED = 'DELETE_SALESCALL_REJECTED',
  UPDATE_SALESCALL = 'UPDATE_SALESCALL',
  UPDATE_SALESCALL_REJECTED = 'UPDATE_SALESCALL_REJECTED',
  FETCH_PAGED_SALES_CALLS = 'FETCH_PAGED_SALES_CALLS',
  FETCH_SALESCALLS = 'FETCH_SALESCALLS',
  FETCH_SALESCALLS_REJECTED = 'FETCH_SALESCALLS_REJECTED',
  FETCH_SALESCALLS_BY_DATE = 'FETCH_SALESCALLS_BY_DATE',
  FETCH_SALESCALLS_BY_DATE_FULFILLED = 'FETCH_SALESCALLS_BY_DATE_FULFILLED',
  FETCH_SALESCALLS_BY_DATE_REJECTED = 'FETCH_SALESCALLS_BY_DATE_REJECTED',
  PROCESS_SALESCALLS = 'PROCESS_SALESCALLS',
  RESET_SALESCALL_IDS = 'RESET_SALESCALL_IDS',
  SET_PAGED_SALES_CALLS = 'SET_PAGED_SALES_CALLS',
  TOGGLE_LOADING_PAGED = 'TOGGLE_LOADING_PAGED'
}
